import React from "react"
import PropTypes from "prop-types";
import "./BreadCrumbStyleSheet.css"
import {Link} from "react-router-dom";


const RaikoBreadcrumb = (
    {
        breadCrumbItems,
        className
    }) => {

    return (
        <ul className={`page-title-bread-crumb-container ${className}`}>
            {
                breadCrumbItems && breadCrumbItems.map((item, index) => {
                    if (item.link && item.link.length > 0)
                        return <li>
                            <Link to={item.link}>
                                {item.title}
                            </Link>
                        </li>
                    else
                        return <li>
                            {item.title}
                        </li>
                })

                /*itemsMap && Object.entries(itemsMap).map(([itemLink, itemTitle]) => {
                    return <li>
                        <a href={itemLink}>
                            {itemTitle}
                        </a>
                    </li>
                })*/

            }
        </ul>
    )
}

RaikoBreadcrumb.propTypes = {
    breadCrumbItems: PropTypes.array.isRequired
}


export default RaikoBreadcrumb


export function raikoBreadCrumbItemGenerator(title, link = "") {
    return {
        title,
        link
    }
}